(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-dawn-parallax-image"] && !Shopify.designMode) return;
  try {
     
  class KsParallaxImage extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScript()

      setTimeout(() => {
        const instance = new simpleParallax(this.querySelectorAll('.parallax-img-init'),  {
          orientation: this.dataset.parallaxOrientation,
          scale: Number(this.dataset.parallaxScale)
        }) 
      }, 250)
    } 

    async injectVendorScript () {
      if (!window.Backpax) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/simple-parallax-js@5.6.2/dist/simpleParallax.min.js')
        script.setAttribute('integrity', 'sha256-GBIPMHSjsTxzIyJuhuk7wWz8z2oKeev8qW/c3IgOeVQ=')
        script.setAttribute('crossorigin', 'anonymous')
        document.head.appendChild(script) 
      }
    }
  }
  customElements.define('ks-parallax-image', KsParallaxImage)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

      window.addEventListener('scroll', () => {
        if (window.scrollY > top) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.clientHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = 0
        }
      })
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        this.querySelectorAll('img').forEach(elem => {
          elem.src = variantImg
        })
 
        this.querySelectorAll('.price').forEach(elem => {
          if (variantComparePrice.length) {
            elem.classList.add('price--on-sale')
            elem.querySelector('.price__sale .price-item--regular').textContent = variantComparePrice
            elem.querySelector('.price__sale .price-item--sale').textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            elem.querySelector('.price__regular .price-item--regular').textContent = variantPrice
          }
        })

        this.querySelectorAll('button[name="add"]').forEach(btn => {
          if (selectedOption.disabled) {
            btn.disabled = true
            btn.querySelector('span').textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            btn.querySelector('.sold-out-message').classList.add('hidden')
            btn.querySelector('span').textContent = this.dataset.textAddToCart
          }
        })
      })
    }

    handleMainVariantChange () {
      this.mainVariantInput.addEventListener('change', (event) => {
        this.variantSelector.value = this.mainVariantInput.value
        this.variantSelector.dispatchEvent(new Event('change'))
      })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ks-wishlist"] && !Shopify.designMode) return;
  try {
     
  class KsWishlist extends HTMLElement {
    constructor () {
      super ()

      this.localStorageKey = 'ks-wishlist-v2'
      this.products = []

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
      this.querySelector('#KsWishlistDrawer-Overlay').addEventListener('click', this.close.bind(this))
      this.seIconsAccessibility()
      this.fetchProducts()
      
      document.querySelectorAll('.menu-drawer__wishlist').forEach(elem => {
        elem.querySelector('[data-text]').textContent = this.dataset.textIconText
      })

      this.querySelectorAll('.ks-wishlist-btm-clear-all').forEach(btn => {
        btn.addEventListener('click', this.clearAll.bind(this))
      })
    }

    seIconsAccessibility() {
      document.querySelectorAll('.ks-wishlist-icon').forEach(elem => {
        elem.addEventListener('click', (event) => {
          event.preventDefault()
          this.open(elem)
        })
        elem.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault()
            this.open(elem)
          }
        })
      })
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy)

      setTimeout(() => {
        this.classList.add('animate', 'active')
      })

      this.addEventListener(
        'transitionend',
        () => {
          const containerToTrapFocusOn = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : document.getElementById('KsWishlistDrawer')
          const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')
          trapFocus(containerToTrapFocusOn, focusElement)
        },
        { once: true }
      )

      document.body.classList.add('overflow-hidden')
    }

    close() {
      this.classList.remove('active')
      removeTrapFocus(this.activeElement)
      document.body.classList.remove('overflow-hidden')
    }

    setActiveElement(element) {
      this.activeElement = element
    }

    setProductInLocalStorage (productId, timestamp) {
      let localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
      
      const isWishlisted = localStorageData.some((elem) => elem.id === productId)

      if (isWishlisted) {
        localStorageData = localStorageData.filter((elem) => elem.id !== productId)
      } else {
        localStorageData.unshift({
          id: productId,
          timestamp: timestamp
        })
      }

      localStorageData = localStorageData.slice(0, Number(this.dataset.limit))
      localStorage.setItem(this.localStorageKey, JSON.stringify(localStorageData))
      this.fetchProducts()
    }

    async fetchProducts() {
      if (!this.dataset.accessToken.length) {
        this.querySelector('.ks-wishlist-no-api').removeAttribute('hidden')
        return 
      }

      const query = `
        query getProductsByIds($ids: [ID!]!, $countryCode: CountryCode! $maxWidth: Int, $maxHeight: Int) @inContext(country: $countryCode) {
          nodes(ids: $ids) {
            ... on Product {
              id
              title
              handle
              onlineStoreUrl
              availableForSale
              featuredImage {
                url(transform: { maxWidth: $maxWidth, maxHeight: $maxHeight, crop: CENTER })
                altText
                width
                height
              }
              compareAtPriceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              variants(first: 100) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    priceV2 {
                      amount
                      currencyCode
                    }
                    image {
                      url(transform: { maxWidth: $maxWidth, maxHeight: $maxHeight, crop: CENTER })
                      altText
                      width
                      height
                    }
                  }
                }
              }
              metafields(identifiers: [ 
                { namespace: "reviews", key: "rating" },
                { namespace: "reviews", key: "rating_count" }
              ]) {
                key
                value
              }
            }
          }
        }
      ` 

      const localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
      const ids = localStorageData.map(product => `gid://shopify/Product/${product.id}`)

      let imgWidth, imgHeight

      switch (this.dataset.imgRatio) {
        case 'adapt':
          imgWidth = 600
          break
        case 'portrait':
          imgWidth = 480
          imgHeight = 600
          break
        default:
          imgWidth = 600
          imgHeight = 600
      }

      const variables = {
        ids: ids,
        countryCode: this.dataset.countryCode,
        maxWidth: imgWidth, 
        maxHeight: imgHeight
      }

      const response = await fetch(`https://${this.dataset.shopifyDomain}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': this.dataset.accessToken,
        },
        body: JSON.stringify({ query, variables }),
      })

      // console.log(response)

      const data = await response.json()
      // console.log(data)

      if (data.errors) {
        this.querySelector('.ks-wishlist-no-api').removeAttribute('hidden')
        return 
      }
      
      let products = data.data.nodes
      products = products.filter(product => product !== null)

      products.map(product => {
        product.timestamp = localStorageData.find(elem => product.id.includes(elem.id)).timestamp
        return product
      })
      // console.log(products)

      this.products = products

      this.handleDrawerContents()
    }

    handleDrawerContents () {
      if (this.products.length) {
        this.querySelector('.ks-wishlist-empty').setAttribute('hidden', 'hidden')
        this.classList.remove('is-empty')

        let productList = ''

        this.products.forEach(product => {
          let variantsHTML = ''

          product.variants.edges.forEach(elem => {
            const variant = elem.node
            const id = variant.id.split('/ProductVariant/')[1]
            const title = variant.title
            const price = variant.priceV2.amount.replace('.0', '')
            const currencyCode = variant.priceV2.currencyCode
            const availableForSale = variant.availableForSale
            const img = variant.image.url
            
            variantsHTML += `
              <option 
                value="${id}" ${availableForSale ? '' : 'disabled'}
                data-img="${img}">
                ${title} - ${this.formatPrice(price, currencyCode)}
              </option>
            `
          })

          const productId = product.id.split('/Product/')[1]
          const hasOneVariant = product.variants.edges.length === 1
          const priceVaries = product.priceRange.minVariantPrice.amount !== product.priceRange.maxVariantPrice.amount
          let rating
          let ratingCount
          let ratingDecimal
          
          product.metafields.forEach(metafield => {
            if (metafield && metafield.key === 'rating') {
              rating = JSON.parse(metafield.value)

              ratingDecimal = 0
              let decimal = rating.value % 1
              if (decimal >= 0.3 && decimal <= 0.7) {
                ratingDecimal = 0.5
              } else if ( decimal > 0.7) {
                ratingDecimal = 1
              }
            }
            if (metafield && metafield.key === 'rating_count') {
              ratingCount = Number(metafield.value)
            }
          })

          productList += `
            <div class="ks-wishlist-drawer-product-item" role="listitem">
              <a href="/products/${product.handle}" tabindex="-1">
                <img 
                  src="${product.featuredImage.url}"
                  class="img-fluid" 
                  alt="${product.featuredImage.altText}" 
                  width="600" 
                  height="600"  
                  loading="lazy">
              </a>
              <div class="ks-wishlist-drawer-product-item-center">
                <a href="/products/${product.handle}" class="ks-wishlist-drawer-product-title h4 cart-item__name">
                  ${product.title}
                </a>
                <div class="ks-wishlist-drawer-product-rating" ${rating ? '' : 'hidden'} ${this.dataset.showRating === 'true' ? '' : 'hidden'}>
                  <div class="rating" role="img" aria-label="${rating?.value} out of ${rating?.scale_max} stars">
                    <span 
                      aria-hidden="true" 
                      class="rating-star" 
                      style="
                        --rating: ${Math.floor(rating?.value)}; 
                        --rating-max: ${rating?.scale_max}; 
                        --rating-decimal: ${ratingDecimal};
                      ">
                    </span>
                  </div>
                  <p class="rating-text caption">
                    <span aria-hidden="true">${rating?.value} / ${rating?.scale_max}</span>
                  </p>
                  <p class="rating-count caption">
                    <span aria-hidden="true">(${ratingCount})</span>
                    <span class="visually-hidden">${ratingCount} total reviews</span>
                  </p>
                </div>
                <div 
                  class="
                    ks-wishlist-drawer-product-price price 
                    ${ product.compareAtPriceRange.minVariantPrice.amount === '0.0' ? '' : 'price--on-sale'}
                  ">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textRegularPrice}
                      </span>
                      <span class="price-item price-item--regular">
                        ${priceVaries ? 'From ': ''} 
                        ${this.formatPrice(
                          product.priceRange.minVariantPrice.amount.replace('.0', ''),
                          product.priceRange.minVariantPrice.currencyCode
                        )}
                      </span>
                    </div>
                    <div class="price__sale">
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textRegularPrice}
                      </span>
                      <span>
                        <s class="price-item price-item--regular">
                          ${this.formatPrice(
                            product.compareAtPriceRange.minVariantPrice.amount.replace('.0', ''),
                            product.compareAtPriceRange.minVariantPrice.currencyCode
                          )}
                        </s>
                      </span>
                      <span class="visually-hidden visually-hidden--inline">
                        ${this.dataset.textSalePrice}
                      </span>
                      <span class="price-item price-item--sale price-item--last">
                        ${priceVaries ? 'From ': ''} 
                        ${this.formatPrice(
                          product.priceRange.minVariantPrice.amount.replace('.0', ''),
                          product.priceRange.minVariantPrice.currencyCode
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <product-form ${this.dataset.showAtcForm === 'true' ? '' : 'hidden'}>
                  <form method="post" 
                    action="${this.dataset.routesCartAdd}" 
                    accept-charset="UTF-8" 
                    class="ks-wishlist-drawer-product-form form" 
                    enctype="multipart/form-data" 
                    novalidate="novalidate" 
                    data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="product-id" value="${productId}">
                    <div class="field-wrapper" ${hasOneVariant ? 'hidden' : ''}>
                      <div class="ks-wishlist-drawer-product-select select">
                        <select 
                          name="id" 
                          class="select__select"
                          aria-label="Select variant">
                            ${variantsHTML}
                        </select>
                        <span class="svg-wrapper">
                          <svg class="icon icon-caret" viewBox="0 0 10 6">
                            <path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path>
                            </svg>
                        </span>
                      </div>
                    </div>
                    <button 
                      type="submit" 
                      name="add" 
                      class="ks-wishlist-drawer-product-btn button button--full-width ${this.dataset.btnStyle}"
                      aria-haspopup="dialog"
                      ${product.availableForSale ? '' : 'disabled'}>
                      <span>
                        ${product.availableForSale ? this.dataset.textAddToCart : this.dataset.textSoldOut}
                      </span>
                      <div class="loading__spinner hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>
                      </div>
                    </button>
                  </form>
                </product-form>
                <div class="ks-wishlist-drawer-product-bottom">
                   <p class="ks-wishlist-drawer-product-timestamp" ${this.dataset.showTimestamp === 'true' ? '' : 'hidden'}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    ${this.handleTimestamp(product.timestamp)}
                  </p>
                  <a 
                    href="javascript:void(0)" 
                    class="ks-wishlist-drawer-product-remove" 
                    data-product-id="${productId}">
                    ${this.dataset.textProductRemove}
                  </a>
                </div>
              </div>
            </div>
          `
        })

        this.querySelector('.ks-wishlist-drawer-product-list-wrapper').removeAttribute('hidden')
        this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = productList

        this.querySelectorAll('.ks-wishlist-drawer-product-item select[name="id"]').forEach(select => {
          select.addEventListener('change', (event) => this.onVariantChange(select, event))
        })

        this.querySelectorAll('.ks-wishlist-drawer-product-item button[name="add"]').forEach(btn => {
          btn.addEventListener('click', () => {
            setTimeout(() => {
              this.close()
            }, 400)
          })
        })

        this.querySelectorAll('.ks-wishlist-drawer-product-remove').forEach(btn => {
          btn.addEventListener('click', (event) => {
            event.preventDefault()
            
            let localStorageData = JSON.parse(localStorage.getItem(this.localStorageKey)) || []
            localStorageData = localStorageData.filter((elem) => elem.id !== Number(btn.dataset.productId))
            localStorage.setItem(this.localStorageKey, JSON.stringify(localStorageData))
            this.fetchProducts()

            document.querySelectorAll('.ks-wishlist-btn').forEach(elem => {
              elem.adjustBtn()
            })
          })
        })

      } else {
        this.querySelector('.ks-wishlist-empty').removeAttribute('hidden')
        this.classList.add('is-empty')
        this.querySelector('.ks-wishlist-drawer-product-list-wrapper').setAttribute('hidden', 'hidden')
        this.querySelector('.ks-wishlist-drawer-product-list').innerHTML = ''
      }

      this.setCountBubles()
    }

    clearAll() {
      this.products = []
      localStorage.removeItem(this.localStorageKey)
      this.handleDrawerContents()
      // this.close()

      document.querySelectorAll('.ks-wishlist-btn').forEach(elem => {
        elem.adjustBtn()
      })
    }

    formatPrice(amount, currencyCode) {
      const currencySymbols = {
        USD: '$',
        EUR: '€',
        GBP: '£',
        JPY: '¥',
        AUD: 'A$',
        CAD: 'C$'
      }
      const symbol = currencySymbols[currencyCode] || currencyCode;
      return `${symbol}${amount}`
    }
    
    onVariantChange (select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.img

      if (imgSrc) {
        const img = select.closest('.ks-wishlist-drawer-product-item').querySelector('img')
        img.src = imgSrc
      }
    }
    
    handleTimestamp(timestamp) {
      const now = Date.now()
      const secondsAgo = Math.floor((now - timestamp * 1000) / 1000)

      if (secondsAgo < 60) return this.dataset.textMomentsAgo
      if (secondsAgo < 3600) return `${Math.floor(secondsAgo / 60)} ${this.dataset.textMinAgo}`
      if (secondsAgo < 86400) return `${Math.floor(secondsAgo / 3600)} ${this.dataset.textHoursAgo}`
      if (secondsAgo < 604800) return `${Math.floor(secondsAgo / 86400)} ${this.dataset.textDaysAgo}`

      const date = new Date(timestamp * 1000)
      return `${date.toLocaleDateString()}`
    }

    setCountBubles () {
      document.querySelectorAll('.ks-wishlist-icon').forEach(elem => {
        elem.querySelectorAll('[data-ks-count-text]').forEach(elem2 => {
          elem2.textContent = this.products.length

          elem2.closest('.ks-wishlist-count-bubble')?.setAttribute('data-ks-count', this.products.length)
        })
      })
    }
  }
  customElements.define('ks-wishlist-drawer', KsWishlist)

  class KsWishlistBtn extends HTMLElement {
    constructor () {
      super()

      this.btn = this.querySelector('button')
      this.wishlistDrawer = document.querySelector('ks-wishlist-drawer')

      this.adjustBtn()

      this.btn.addEventListener('click', async (event) => {
        event.preventDefault()

        this.wishlistDrawer.setProductInLocalStorage(
          Number(this.dataset.productId),
          Number(this.dataset.timestamp)
        )

        this.adjustBtn()
      })
    }

    adjustBtn () {
      const localStorageData = JSON.parse(localStorage.getItem(this.wishlistDrawer.localStorageKey)) || []
      const isWishlisted = localStorageData.some((elem) => elem.id === Number(this.dataset.productId))

      if (isWishlisted) {
        this.btn.classList.add('active')
        this.btn.setAttribute('aria-label', this.dataset.textRemove)
        this.btn.setAttribute('aria-pressed', 'true')
      } else {
        this.btn.classList.remove('active')
        this.btn.setAttribute('aria-label', this.dataset.textAdd)
        this.btn.setAttribute('aria-pressed', 'false')
      }
    }
  }
  customElements.define('ks-wishlist-btn', KsWishlistBtn)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-custom"] && !Shopify.designMode) return;
  try {
     
  if (Shopify.designMode) return

  // Create cookie function
  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#ks-newsletter-dialog')

  // Close dialog if clicked outside
  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.ks-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close() 
    }
  })

  // Close button
  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?ks-newsletter-popup)
  if (window.location.href.includes('ks-newsletter-popup')) {
    dialog.showModal() 
    return
  }

  // Do not show the dialog if the cookie is still present (config from settings)
  if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
    return
  }

  (async () => {
    // Show the dialog on page load after some time has passed (config from settings)
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    // Create a cookie so that we don't show the dialog for some time (config from settings)
    createCookie('ks-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();


  } catch(e) { console.error(e); }
})();
})();
